(function () {
  'use strict';

  const style = document.createElement('style');
  if (/\/(?:pages\/(?:privaatsus|kupsiste-poliitika)|policies\/privacy-policy)\/?$/.test(window.location.pathname)) {
    style.textContent = '#shopify-pc__banner { display: none !important; }';
    document.head.appendChild(style);
    return;
  }
  style.textContent = `
    html.jk-cookie-choice-open,
    html.jk-cookie-choice-open body {
      overflow: hidden !important;
      overscroll-behavior: none;
    }
    #jk-cookie-backdrop {
      display: block !important;
      position: fixed;
      inset: 0;
      z-index: 2147483600;
      background: rgba(23, 30, 34, .62);
      touch-action: none;
    }
    #jk-cookie-backdrop[hidden] { display: none !important; }
    #shopify-pc__banner {
      position: fixed !important;
      inset: 50% auto auto 50% !important;
      transform: translate(-50%, -50%) !important;
      z-index: 2147483601 !important;
      box-sizing: border-box !important;
      width: calc(100% - 32px) !important;
      max-width: 660px !important;
      max-height: calc(100vh - 32px) !important;
      max-height: calc(100dvh - 32px) !important;
      margin: 0 !important;
      padding: 36px !important;
      overflow: auto !important;
      overscroll-behavior: contain;
      border: 1px solid #e4e1d9 !important;
      border-radius: 16px !important;
      background: #fff !important;
      color: #263238 !important;
      box-shadow: 0 24px 80px rgba(0, 0, 0, .28) !important;
    }
    #shopify-pc__banner .shopify-pc__banner__wrapper { display: block !important; }
    #shopify-pc__banner:focus { outline: none !important; }
    #shopify-pc__banner .shopify-pc__banner__body { width: 100% !important; margin: 0 !important; }
    #shopify-pc__banner h2 {
      margin: 0 0 16px !important;
      font-size: 26px !important;
      line-height: 1.3 !important;
    }
    #shopify-pc__banner p { margin: 0 !important; font-size: 16px !important; line-height: 1.65 !important; }
    #shopify-pc__banner a { color: inherit !important; text-decoration: underline !important; }
    #shopify-pc__banner .shopify-pc__banner__btns {
      display: grid !important;
      grid-template-columns: 1fr;
      gap: 12px !important;
      width: 100% !important;
      margin: 28px 0 0 !important;
    }
    #shopify-pc__banner .shopify-pc__banner__btns button {
      order: 0 !important;
      box-sizing: border-box !important;
      width: 100% !important;
      min-height: 50px;
      margin: 0 !important;
      padding: 13px 16px !important;
      border: 1px solid #30393f !important;
      border-radius: 8px !important;
      background: #30393f !important;
      color: #fff !important;
      font: inherit !important;
      font-size: 15px !important;
      font-weight: 600 !important;
      line-height: 1.4 !important;
      text-decoration: none !important;
      white-space: normal !important;
      cursor: pointer;
    }
    #shopify-pc__banner #shopify-pc__banner__btn-decline { display: none !important; }
    #shopify-pc__banner #shopify-pc__banner__btn-manage-prefs {
      grid-column: 1 / -1;
      background: #fff !important;
      color: #30393f !important;
    }
    #shopify-pc__banner button:hover { filter: brightness(.92); }
    #shopify-pc__banner :focus-visible { outline: 3px solid #8a733e !important; outline-offset: 3px; }
    #shopify-pc__prefs { z-index: 2147483602 !important; }
    @media (max-width: 480px) {
      #shopify-pc__banner { padding: 24px !important; }
      #shopify-pc__banner h2 { font-size: 23px !important; }
      #shopify-pc__banner .shopify-pc__banner__btns { grid-template-columns: 1fr; margin-top: 22px !important; }
    }
  `;
  document.head.appendChild(style);

  const labelsByLanguage = {
    et: { manage: 'Kohanda valikuid', accept: 'Nõustu kõigiga', decline: 'Ainult vajalikud', save: 'Salvesta valikud' },
    en: { manage: 'Customize choices', accept: 'Accept all', decline: 'Necessary only', save: 'Save choices' },
    ru: { manage: 'Настроить выбор', accept: 'Принять все', decline: 'Только необходимые', save: 'Сохранить выбор' },
  };
  const labels = labelsByLanguage[document.documentElement.lang.split('-')[0]];
  const inertElements = new Map();
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let activeDialog = null;
  let previousFocus = null;
  let backdrop = null;
  let updateQueued = false;
  let observer;

  const isVisible = (element) => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const setLabel = (id, text) => {
    const button = document.getElementById(id);
    if (!button || !text) return;
    if (button.textContent.trim() !== text) button.textContent = text;
    button.setAttribute('aria-label', text);
  };
  const restoreElement = (element, wasInert) => {
    element.inert = wasInert;
    inertElements.delete(element);
  };

  const update = () => {
    observer.disconnect();
    const banner = document.getElementById('shopify-pc__banner');
    const preferences = document.getElementById('shopify-pc__prefs__dialog');

    if (labels) {
      setLabel('shopify-pc__banner__btn-accept', labels.accept);
      setLabel('shopify-pc__banner__btn-decline', labels.decline);
      setLabel('shopify-pc__banner__btn-manage-prefs', labels.manage);
      setLabel('shopify-pc__prefs__header-accept', labels.accept);
      setLabel('shopify-pc__prefs__header-decline', labels.decline);
      setLabel('shopify-pc__prefs__header-save', labels.save);
    }

    if (banner) {
      const manage = document.getElementById('shopify-pc__banner__btn-manage-prefs');
      if (manage && manage !== manage.parentElement.lastElementChild) manage.parentElement.appendChild(manage);
    }

    [banner, preferences].filter(Boolean).forEach((dialog) => {
      dialog.querySelectorAll('a[href*="privacy-policy"]').forEach((link) => {
        link.href = 'https://jahikala.ee/pages/privaatsus';
        link.removeAttribute('target');
        link.removeAttribute('rel');
      });
    });

    const nextDialog = isVisible(preferences) ? preferences : isVisible(banner) ? banner : null;
    if (nextDialog && !backdrop) {
      backdrop = document.createElement('div');
      backdrop.id = 'jk-cookie-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.appendChild(backdrop);
    }
    if (backdrop) backdrop.hidden = !nextDialog || nextDialog === preferences;
    document.documentElement.classList.toggle('jk-cookie-choice-open', Boolean(nextDialog));

    if (nextDialog) {
      nextDialog.setAttribute('aria-modal', 'true');
      nextDialog.tabIndex = -1;
      Array.from(document.body.children).forEach((element) => {
        if (element === backdrop || element.contains(nextDialog) || /^(SCRIPT|STYLE|LINK)$/.test(element.tagName)) {
          if (inertElements.has(element)) restoreElement(element, inertElements.get(element));
          return;
        }
        if (!inertElements.has(element)) inertElements.set(element, element.inert);
        element.inert = true;
      });
      if (activeDialog !== nextDialog) {
        if (!activeDialog) previousFocus = document.activeElement;
        activeDialog = nextDialog;
        nextDialog.focus({ preventScroll: true });
      }
    } else {
      inertElements.forEach((wasInert, element) => restoreElement(element, wasInert));
      if (activeDialog && previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
      activeDialog = null;
      previousFocus = null;
    }

    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden'] });
  };

  observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => mutation.type === 'childList' || mutation.target.closest('#shopify-pc__banner, #shopify-pc__prefs'));
    if (!relevant || updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(() => {
      updateQueued = false;
      update();
    });
  });

  window.addEventListener('keydown', (event) => {
    if (!activeDialog) return;
    if (event.key === 'Escape' && activeDialog.id === 'shopify-pc__banner') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    if (event.key !== 'Tab') return;
    const controls = Array.from(activeDialog.querySelectorAll(focusableSelector)).filter((element) => element.tabIndex >= 0 && isVisible(element));
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!first) {
      event.preventDefault();
      activeDialog.focus();
    } else if (!controls.includes(document.activeElement) || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    }
  }, true);

  update();
})();
